module.exports = __webpack_public_path__ + "img/bookmark.7b98965d.svg";